import { render, staticRenderFns } from "./EntityAddSelectWidget.vue?vue&type=template&id=39ba6200&scoped=true"
import script from "./EntityAddSelectWidget.vue?vue&type=script&lang=js"
export * from "./EntityAddSelectWidget.vue?vue&type=script&lang=js"
import style0 from "./EntityAddSelectWidget.vue?vue&type=style&index=0&id=39ba6200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ba6200",
  null
  
)

export default component.exports